module["exports"] = [
  "#{street}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/street_name.js
// module id = 2045
// module chunks = 0